// extracted by mini-css-extract-plugin
module.exports = {"login_card":"style_login_card__pTdiI"};